<template>
  <v-card
    height="630px"
    class=""
    rounded
  >
    <v-img
      class="close"        
      src="../assets/close1.svg"
      color="#ffffff"       
    ></v-img>
    <v-card-title>
      <span style="color:#2B2B2B" class="font-weight-bold text-h5">プロフィール</span>
      <v-spacer></v-spacer>
      <v-btn
        v-if="appbarpro"
        elevation="0"
        color="#008CFF"
        style="color:white !important; font-size:15px;"
        class="font-weight-bold"
        @click="profileCheck=hitokoto+proLink+message,profile = false,profileEdit = true"
      >
        プロフィールを編集する
      </v-btn>
      <v-btn
        v-else
        elevation="0"
        color="#008CFF"
        style="color:white !important; font-size:15px;"
        class="font-weight-bold"
        @click="profile = false"
      >
        プロフィールを閉じる
      </v-btn>
    </v-card-title>
    <v-container fluid>
      <v-row dense>
        <v-col
          cols="4"
          class="text-center"
        >
          <v-card
            elevation="0"
          >
            <v-avatar
              size="224"
            ><!--
            <img
              v-show="uploadedImage"
              class="preview-item-file"
              :src="uploadedImage"
              alt=""
            >-->
            </v-avatar>
          </v-card>
          <v-chip color="#BA0009" dark class="mt-4" v-if="baseAdmins.some((el) => el === theProfile.id)">ベースの管理者</v-chip>
        </v-col>
        <v-col
          cols="8"
        >
          <v-card
            height="400"
            elevation="0"
          >
            <v-card-title class="py-1" style="color:#66BAFF">
              ハンドルネーム
            </v-card-title>
            <v-card-title class="py-0">
              <div style="font-size:36px;">{{theProfile.name}}</div>
            </v-card-title>
            <v-card-title class="pt-10 pb-0" style="color:#66BAFF">
              役職・担当
            </v-card-title>
            <v-card-title class="py-0">
              <div style="color:#707070; font-size:18px;">{{theProfile.message}}</div>
            </v-card-title>
            <v-card-title class="py-0 pt-8" style="color:#66BAFF">
              ひとこと
            </v-card-title>
            <v-card-title class="pt-0">
              <div style="color:#707070; font-size:18px;">{{theProfile.hitokoto}}</div>
            </v-card-title>
            <v-card-title class="py-0 pt-12" style="color:#66BAFF">
              関連リンク
            </v-card-title>
            <v-card-title class="py-0" tag="a">
              <v-btn 
                :href="theProfile.relatedLink" 
                style="color:#707070; font-size:18px; text-transform: none;"
                plain
                target="_blank"
              >
                {{theProfile.relatedLink}}
              </v-btn>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-col class="px-0 pt-10 pb-0">
      <v-card
        elevation="0"
      >
        <v-img
          src="../assets/png/3005.png"
          class="white--text align-end ma-0"
          height="100px"
        ></v-img>
      </v-card>
    </v-col>
  </v-card>
</template>

<script>
import firebase from 'firebase'
export default {
  props:{
    theProfile: Object,
    baseAdmins: Array
  },
}
</script>
<style scoped>
.close{
  position: fixed;
  right: 1%;
  top: 1%;
  width: 4%;
}
</style>